<template>
  <div class="pag-news-detail">
    <div class="detail-hd">
      <div class="detail-title">
        {{detailData.newsTitle}}
      </div>
      <div class="detail-time">发布时间：{{detailData.createTime|formtDay}}</div>
    </div>
    <div class="detail-content" v-html="detailData.newsTest"></div>
    <!-- <div class="bottom-tool">
      <div class="bottom-btn prev-btn">
        <img src="../assets/news_detail_prev_btn.png" alt="">
      </div>
      <div class="bottom-btn go-back" @click="goback">
        <img src="../assets/news_detail_back_btn.png" alt="">
      </div>
      <div class="bottom-btn next-btn">
        <img src="../assets/news_detail_next_btn.png" alt="">
      </div>
    </div> -->
  </div>
</template>
<script>
import api from '@/api'
import dayjs from 'dayjs'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
export default {
  name: 'PageNewsDetail',
  data () {
    return {
      detailData: {}
    }
  },
  activated () {
    if (this.$route.query.id) {
      this.getNewsDetail(this.$route.query.id)
    }
  },
  filters: {
    formtDay (val) {
      return dayjs(val).format('YYYY-MM-DD')
    }
  },
  methods: {
    async getNewsDetail (id) {
      showLoading()
      const { errCode, errMsg, data } = await api.getNewsDetail({ id: id })
      hideLoading()
      if (errCode === 0) {
        this.detailData = data
      } else {
        showAlert(errMsg)
      }
    }
    // goback () {
    //   this.$router.go(-1)
    // }
  }
}
</script>
<style lang="less" scoped>
.pag-news-detail{
  padding: 50px;
  background-color: #ffffff;
  .detail-hd{
    padding-bottom: 40px;
    border-bottom: 1PX solid @main-gray5;
    margin-bottom: 40px;
    .detail-title{
      font-size: 48px;
      color: @main-gray2;
      padding-bottom: 20px;
    }
    .detail-time{
      font-size: 24px;
      color: @main-gray4;
    }
  }
  .detail-content{
    font-size: 24px;
    color: @main-gray3;
    line-height: 1.8;
    overflow: hidden;
    /deep/ img{
      width: 100%!important;
      height: auto;
    }
    /deep/ video{
      width: 100%!important;
      height: auto;
    }
  }
  .bottom-tool{
    display: flex;
    justify-content: space-between;
    padding: 60px 0 120px;
    .bottom-btn{
      width: 88px;
      height: 88px;
      img{
        width: 100%;
      }
    }
  }
}
</style>
